import { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

import DynamicIcon from '@/components/DynamicIcon'
import { Media } from '@/components/Media'
import RichText from '@/components/RichText'
import { Button } from '@/components/ui/button'
import { TeamMember } from '@/payload-types'

interface MemberModalProps {
  member: TeamMember
}

const MemberModal: React.FC<MemberModalProps> = ({ member }) => {
  return (
    <div
      className="mx-4 max-h-[calc(100svh-2rem-env(safe-area-inset-bottom))] overflow-y-auto rounded-2xl bg-background px-4 pt-4 max-[72rem]:mx-0 md:px-10 md:pt-10"
      data-lenis-prevent
    >
      <div className="flex flex-col gap-8 border-b border-border pb-8 md:flex-row xl:gap-16">
        <div className="relative aspect-6/7 size-full overflow-hidden rounded-xl md:sticky md:top-0">
          {/* Background image */}
          <div>
            {member.image && (
              <Media
                resource={member.image}
                fill
                pictureClassName="size-full"
                imgClassName="absolute inset-0 size-full object-cover object-center"
              />
            )}
          </div>
        </div>
        <div>
          <h2 className="py-4 font-family-body text-2xl leading-9 font-semibold text-foreground lg:text-3xl">
            {member.name}
          </h2>
          <p className="font-family-body text-base leading-6 text-muted-foreground lg:text-lg">
            {member.jobTitle}
          </p>
          <RichText
            data={member?.bio as DefaultTypedEditorState}
            className="py-4 font-family-body text-base leading-7 text-foreground lg:text-lg"
          />
        </div>
      </div>
      <div className="flex w-full justify-end gap-2 py-4">
        {member.socialLinks?.map((social) =>
          social.url ? (
            <Button
              variant="icon"
              key={social.platform}
              asChild
              className="flex size-10 items-center justify-center rounded-xl bg-neutral-200 p-0 hover:bg-neutral-300"
            >
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${member.name} on ${social.platform}`}
              >
                {social.platform === 'x' ? (
                  <Media
                    resource="/media/logo_x.svg"
                    alt="X"
                    width={20}
                    height={20}
                    htmlelement={null}
                    pictureClassName="block size-5"
                    imgClassName="size-5"
                  />
                ) : (
                  <DynamicIcon name={social.platform} className="size-5 text-foreground" />
                )}
              </a>
            </Button>
          ) : null,
        )}
      </div>
    </div>
  )
}

export default MemberModal
